import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Model } from "appworks/model/model";
import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { Contract } from "appworks/utils/contracts/contract";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";

export function StartSpinCommand(): Contract<void> {
    const gameplay = gameState.getCurrentGame();

    Services.transaction.setBalance(gameplay.startBalance);

    const record = gameplay.getCurrentRecord();
    if (record && (record instanceof FreespinRecord || record.getFreespinsWon() > 0)) {
        Services.sound.event(SoundEvent.start_freespin);
    } else {
        Services.sound.event(SoundEvent.start_spin);
    }

    const settings = Model.read().settings;
    const quickSpin = settings.quickSpin || settings.turboSpin;

    return Components.get(AbstractMatrixComponent).startTransition(false, quickSpin);
}
